import React from 'react';
import { FadeUp } from './FadeUp';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Signals Activated',
    desc: 'Key interactions are generated on your content so the algorithm identifies your account as active and worth promoting.'
  }, {
    num: '2',
    title: 'Algorithm Amplifies',
    desc: 'Instagram begins distributing your content beyond your current followers. Your organic reach expands naturally.'
  }, {
    num: '3',
    title: 'Your Profile Builds Trust',
    desc: 'Visitors land on a brand with real presence. That authority perception turns profile visits into clients.'
  }];
  return <section id="como" className="bg-bg-secondary border-y border-cyan/10 text-center relative z-10 py-[72px] md:py-[100px]" data-id="element-130">
      <div className="max-w-[900px] mx-auto px-6" data-id="element-131">
        <p className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-blue-electric mb-4" data-id="element-132">
          The process
        </p>

        <FadeUp data-id="element-133">
          <h2 className="text-[clamp(26px,4vw,36px)] font-heading font-bold uppercase leading-[1.2] tracking-[0.05em] mb-6 mx-auto" data-id="element-134">
            Simple, transparent, effective
          </h2>
        </FadeUp>

        <FadeUp delay={0.1} data-id="element-135">
          <p className="text-white-dim text-base max-w-[560px] leading-[1.7] mx-auto mb-16" data-id="element-136">
            No technical jargon. No complexity. A system that runs alongside
            everything you're already doing.
          </p>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0.5 relative" data-id="element-137">
          {/* Connecting Line for Desktop with Animated Pulse */}
          <div className="hidden md:block absolute top-[36px] left-[16%] right-[16%] h-[2px] bg-cyan/10 overflow-hidden" data-id="element-138">
            <motion.div className="h-full w-[100px] bg-gradient-to-r from-transparent via-cyan to-transparent shadow-[0_0_10px_#00e5ff]" animate={{
            x: ['-100%', '800%']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-139" />
          </div>

          {steps.map((step, i) => <FadeUp key={i} delay={i * 0.08} data-id="element-140">
              <div className="bg-bg-card border border-cyan/10 rounded-sm p-[36px_28px] text-center relative transition-all duration-300 ease-in hover:border-cyan/40 card-glow-hover-lg hover:-translate-y-1 h-full" data-id="element-141">
                {/* Glowing Orb behind number */}
                <div className="orb w-16 h-16 top-[15px] left-1/2 -translate-x-1/2" style={{
              animationDelay: `${i * 1.5}s`
            }} data-id="element-142" />

                <div className="w-[52px] h-[52px] mx-auto mb-[22px] bg-gradient-to-br from-cyan/15 to-cyan/5 border border-cyan rounded-sm flex items-center justify-center text-[20px] font-heading font-bold text-cyan shadow-[0_0_15px_rgba(0,229,255,0.2)] relative z-10" data-id="element-143">
                  {step.num}
                </div>
                <h3 className="text-[15px] font-heading font-semibold uppercase tracking-[0.05em] mb-3" data-id="element-144">
                  {step.title}
                </h3>
                <p className="text-[14px] text-white-dim leading-[1.6]" data-id="element-145">
                  {step.desc}
                </p>
              </div>
            </FadeUp>)}
        </div>

        <FadeUp delay={0.3} data-id="element-146">
          <div className="inline-flex items-center gap-3 bg-cyan/5 border border-cyan/40 rounded-sm p-[16px_28px] mt-12 text-[14px] text-white font-medium" data-id="element-147">
            <span className="w-2 h-2 bg-cyan rounded-sm shadow-[0_0_8px_#00e5ff] shrink-0 animate-pulse-dot" data-id="element-148" />
            <p data-id="element-149">
              <strong className="text-cyan font-heading uppercase tracking-[0.05em] text-[12px]" data-id="element-150">
                Real, verified people
              </strong>{' '}
              will be engaging on your account — active users from our{' '}
              <strong className="text-cyan font-heading uppercase tracking-[0.05em] text-[12px]" data-id="element-151">
                U.S.-based database.
              </strong>
            </p>
          </div>
        </FadeUp>
      </div>
    </section>;
}